<template>
  <div>
    <div v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
        </div>
        <div class="col-xs-12">
          <h5 style="margin-top: 0px;" class="form-block-title">
            Pályázat választás
          </h5>
          <comboboxV2 v-on:onChange="osztondijValtoztat" label="Pályázott ösztöndíj" name="osztondij_id" :errors="errors" id="osztondij_id" :options="palyazhato_osztondijak" v-model="form.values.osztondij_id" />
        </div>

        <template v-if="form.values.osztondij_id != ''">
          <div class="col-xs-12">
            <h5 class="form-block-title">
              Alapadatok
            </h5>
          </div>
          <div v-if="hallgato_alapadatok_t.length > 0" class="col-xs-12">
            <comboboxV2 v-on:onChange="(index) => { szakValt(index); }" label="Szakok" id="szak_id" name="szak_id" :options="szak_combo_opts" v-model="szak_combo_index"/>
          </div>
          <div class="col-xs-6">
            <inputbox :disabled="hallgato_alapadatok_t.length > 0" label="Név" :errors="errors" id="nev" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+" v-model="form.hallgato_alapadatok.nev"/>
            <inputbox v-show="neptunkodLatszik()" label="Neptunkód" :errors="errors" regexp_filter="[a-zA-Z0-9]+" id="neptunkod" name="neptunkod" v-model="form.hallgato_alapadatok.neptunkod"/>
            <inputbox label="Email cím" :errors="errors" id="email" name="email" regexp_filter="[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}" v-model="form.hallgato_alapadatok.email"/>
            <inputbox label="Mobilszám" :errors="errors" id="mobilszam" name="mobilszam" regexp_filter="[+0-9 /-]+" v-model="form.hallgato_alapadatok.mobilszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :disabled="hallgato_alapadatok_t.length > 0" label="Születési hely, idő" :errors="errors" id="szulhelyido" name="szulhelyido" v-model="form.hallgato_alapadatok.szulhelyido"/>
            <inputbox v-show="0" :disabled="hallgato_alapadatok_t.length > 0" label="Képzés szintje" :errors="errors" id="kepzes_szint" name="kepzes_szint" v-model="form.hallgato_alapadatok.kepzes_szint"/>
            <inputbox v-show="szakLatszik()" :disabled="hallgato_alapadatok_t.length > 0" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\-\,]+" label="Szak" :errors="errors" id="szak" name="szak" v-model="form.hallgato_alapadatok.szak"/>
            <inputbox v-show="karLatszik()" :disabled="hallgato_alapadatok_t.length > 0" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\-\,]+" label="Kar" :errors="errors" id="kar" name="kar" v-model="form.hallgato_alapadatok.kar"/>
          </div>
          <div class="col-xs-12">
            <h5 class="form-block-title">
              Pályázat alapadatok
            </h5>
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="Pályázott ösztöndíjas jogviszony időtartama" name="jogviszony_idotartam" id="jogviszony_idotartam" :options="jogviszonyidotartamok" v-model="form.values.jogviszony_idotartam" />
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="2020/2021. tanévi ÚNKP Ösztöndíjban részesültem" name="unkp_reszesult_e" id="unkp_reszesult_e" :options="igen_nem" v-model="form.values.unkp_reszesult_e" />
          </div>
          <div class="col-xs-12">
            <inputbox tooltipDescription="Doktori hallgatók esetén az ösztöndíj keretében végzett kutatás a doktori tanulmányok által megkövetelt kutatómunkához kapcsolódhat, de azon felüli extra kutatási tevékenységnek kell lennie." label="Kutatási/művészeti téma címe" :errors="errors" id="tema_cim" name="tema_cim" v-model="form.values.tema_cim"/>
          </div>
          <div class="col-xs-6">
            <comboboxV2 @onChange="tudomanyAgak(true)" label="Kutatási/művészeti téma tudományterületi besorolása" id="tudomanyterulet" name="tudomanyterulet" :options="tudomanyteruletek" v-model="form.values.tudomanyterulet"/>
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="Kutatási/művészeti téma tudományági besorolása" id="tudomanyag" name="tudomanyag" :options="tudomanyagak" v-model="form.values.tudomanyag"/>
          </div>
          <div class="col-xs-6">
            <inputbox :disabled="temavezetoNevKitoltes()" label="Témavezető neve" :errors="errors" id="temavezeto_neve" name="temavezeto_neve" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+" v-model="form.values.temavezeto_neve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :disabled="temavezetoEmailKitoltes()" label="Témavezető e-mail címe" :errors="errors" id="temavezeto_email" name="temavezeto_email" regexp_filter="[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}" v-model="form.values.temavezeto_email"/>
          </div>
          <div class="col-xs-6">
            <inputbox :disabled="temavezetoTelefonKitoltes()" label="Témavezető mobilszáma" :errors="errors" id="temavezeto_mobil" name="temavezeto_mobil" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" v-model="form.values.temavezeto_mobil"/>
          </div>

          <div v-show="makoveczLatszik()">
            <div class="col-xs-12">
              <h5 class="form-block-title">
                Makovecz Hallgatói Ösztöndíjprogram
              </h5>
            </div>
            <div class="col-xs-6">
              <comboboxV2 tooltipDescription="A 2019/2020., 2020/2021. tanévben Makovecz Hallgatói Ösztöndíjprogram keretében határon túli felsőoktatási intézményben legalább 5 hónap időtartamban teljes szemeszteres részképzésen vagy részképzős tanulmányúton történő részvétel (megkezdett vagy lezárt)." label="Makovecz Hallgatói Ösztöndíjprogram részvétel" name="makovecz_hallgatoi_osztondijprogram_reszvetel" id="makovecz_hallgatoi_osztondijprogram_reszvetel" :options="igen_nem" v-model="form.values.makovecz_hallgatoi_osztondijprogram_reszvetel" />
            </div>
            <div v-show="form.values.makovecz_hallgatoi_osztondijprogram_reszvetel == 'igen'" class="col-xs-12">
              <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'makovecz_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="makovecz_igazolas" label="Igazolás" name="makovecz_igazolas" :loaded_files="form.values.makovecz_igazolas"/>
            </div>
          </div>

          <div v-show="proScientiaLatszik()">
            <div class="col-xs-12">
              <h5 class="form-block-title">
                Pro Scientia/Arte Aranyérem
              </h5>
            </div>
            <div class="col-xs-6">
              <comboboxV2 label="Pro Scientia/Arte Aranyérmet nyert" name="pro_scientia_arte_reszvetel" id="pro_scientia_arte_reszvetel" :options="igen_nem" v-model="form.values.pro_scientia_arte_reszvetel" />
            </div>
            <div v-show="form.values.pro_scientia_arte_reszvetel == 'igen'" class="col-xs-12">
              <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'pro_scientia_arte_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="pro_scientia_arte_igazolas" label="Igazolás" name="pro_scientia_arte_igazolas" :loaded_files="form.values.pro_scientia_arte_igazolas"/>
            </div>
          </div>

          <div v-show="otdkLatszik()">
            <div class="col-xs-12">
              <h5 class="form-block-title">
                OTDK
              </h5>
            </div>
            <div class="col-xs-6">
              <comboboxV2 label="OTDK-n ért-e el I., II. vagy III. helyezést" name="otdk_reszvetel" id="otdk_reszvetel" :options="igen_nem" v-model="form.values.otdk_reszvetel" />
            </div>
            <div v-show="form.values.otdk_reszvetel == 'igen'" class="col-xs-12">
              <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'otdk_reszvetel_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="otdk_reszvetel_igazolas" label="Igazolás" name="otdk_reszvetel_igazolas" :loaded_files="form.values.otdk_reszvetel_igazolas"/>
            </div>
          </div>

          <div v-show="kutatocsoportEgyuttmukodesLatszik()">
            <div class="col-xs-12">
              <h5 class="form-block-title">
                Kutatócsoport együttműködés
              </h5>
            </div>
            <div class="col-xs-6">
              <comboboxV2 tooltipDescription="A kutatási terv kutatócsoport keretében kerül megvalósításra VAGY a pályázó a Magyar Tudományos Akadémiával vagy a fogadó felsőoktatási intézményen kívüli felsőoktatási intézménnyel kutatócsoport keretében együttműködik a kutatási terve megvalósítása során." label="Kutatócsoporttal együttműködés" name="kutatocsoport_egyuttmukodes" id="kutatocsoport_egyuttmukodes" :options="igen_nem" v-model="form.values.kutatocsoport_egyuttmukodes" />
            </div>
            <div v-show="form.values.kutatocsoport_egyuttmukodes == 'igen'" class="col-xs-12">
              <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'kutatocsoport_egyuttmukodes_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="kutatocsoport_egyuttmukodes_igazolas" label="Igazolás" name="kutatocsoport_egyuttmukodes_igazolas" :loaded_files="form.values.kutatocsoport_egyuttmukodes_igazolas"/>
            </div>
          </div>

          <div class="col-xs-12">
            <h5 class="form-block-title">
              Kötelezően feltöltendő dokumentumok
            </h5>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'palyazati_adatlap'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="palyazati_adatlap" label="Kitöltött, aláírt pályázati adatlap" name="palyazati_adatlap" :loaded_files="form.values.palyazati_adatlap"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'palyazati_adatlap_szerkesztheto'); }" accepted_files="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :errors="errors" id="palyazati_adatlap_szerkesztheto" label="Kitöltött pályázati adatlap szerkeszthető (Excel fájl)" name="palyazati_adatlap_szerkesztheto" :loaded_files="form.values.palyazati_adatlap_szerkesztheto"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_kutatasi_terv'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="alairt_kutatasi_terv" :label="form.values.osztondij_id == '21_5' || form.values.osztondij_id == '21_4_2' ? 'Aláírt kutatási terv (pályázó által aláírva)' : 'Aláírt kutatási terv (témavezető és pályázó által aláírva)'" name="alairt_kutatasi_terv" :loaded_files="form.values.alairt_kutatasi_terv"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_palyazoi_nyilatkozat'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="alairt_palyazoi_nyilatkozat" label="Aláírt pályázói nyilatkozat" name="alairt_palyazoi_nyilatkozat" :loaded_files="form.values.alairt_palyazoi_nyilatkozat"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler tooltipDescription="A témavezető és a kari dékán által is aláírt nyilatkozatot a rektori titkárságon (Igazgatási Épület 204-es iroda) kell leadni rektori aláírásra." max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_intezmenyi_fogado_nyilatkozat'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="alairt_intezmenyi_fogado_nyilatkozat" label="Aláírt intézményi fogadó nyilatkozat (témavezető, kari dékán, intézmény rektora által aláírva)" name="alairt_intezmenyi_fogado_nyilatkozat" :loaded_files="form.values.alairt_intezmenyi_fogado_nyilatkozat"/>
          </div>
          <div v-show="tehetseggelFelIgazolasLatszik()" class="col-xs-12">
            <UploadHandler v-on:change="(value) => { changeValue(value, 'tehetseggel_fel_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="tehetseggel_fel_igazolas" label="Igazolás a Pályázati Kiírás 4.1.5. pontjában felsorolt eredményről (versenyeredmények)" name="tehetseggel_fel_igazolas" :loaded_files="form.values.tehetseggel_fel_igazolas"/>
          </div>
          <div v-show="tanulmanyiEredmenyIgazolasLatszik()" class="col-xs-12">
            <UploadHandler v-on:change="(value) => { changeValue(value, 'tanulmanyi_eredmeny_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="tanulmanyi_eredmeny_igazolas" label="A tanulmányi eredményről szóló igazolás hiánytalanul, magyar nyelven kitöltve, Tanulmányi Osztály által hitelesítve" name="tanulmanyi_eredmeny_igazolas" :loaded_files="form.values.tanulmanyi_eredmeny_igazolas"/>
          </div>
          <div v-show="tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="30" v-on:change="(value) => { changeValue(value, 'tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio" :label="tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioCim()" name="tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio" :loaded_files="form.values.tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio"/>
          </div>
          <div v-show="hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveLatszik()" class="col-xs-12">
            <UploadHandler :tooltipDescription="form.values.osztondij_id == '21_5' || form.values.osztondij_id == '21_4_1' || form.values.osztondij_id == '21_4_2' || form.values.osztondij_id == '21_3_2' ? false : 'Amennyiben nem rendelkezik ezen dokumentumok egyikével sem, akkor vagy felvételi jelentkezéről / felvételi döntésről szóló dokumentumot legyen kedves csatolni / munkaviszony esetében pedig a terveiről egy rövid beszámolót, melyik szervezeti egység munkájába kapcsolódna be.'" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve" :label="hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveCim()" name="hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve" :loaded_files="form.values.hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve"/>
          </div>
          <div v-show="felviHuJelentkezesiAdatlapLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'felvi_hu_jelentkezesi_adatlap'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="felvi_hu_jelentkezesi_adatlap" label="Felvi.hu felületéről generálható felvételi jelentkezési adatlap" name="felvi_hu_jelentkezesi_adatlap" :loaded_files="form.values.felvi_hu_jelentkezesi_adatlap"/>
          </div>
          <div v-show="nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve" label="Nyilatkozat felvételi jelentkezésről illetékes Doktori Iskola ügyintézője által hitelesítve (A nyilatkozatot a pályázó készíti el, arra vonatkozóan, hogy melyik doktori iskolába adták be felvételi jelentkezésüket.)" name="nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve" :loaded_files="form.values.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve"/>
          </div>
          <div v-show="bizonyitvanyMasolatLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'bizonyitvany_masolat'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="bizonyitvany_masolat" label="Bizonyítvány másolat (Középfokú képzésben teljesített tanulmányi eredményének utolsó 2 lezárt félévi átlaga lezárt félévenként legalább 4,00 minősítésű legyen.)" name="bizonyitvany_masolat" :loaded_files="form.values.bizonyitvany_masolat"/>
          </div>
          <div v-show="bolyaiKutatasiOsztondijElnyereseIgazolasLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'bolyai_kutatasi_osztondij_elnyerese_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="bolyai_kutatasi_osztondij_elnyerese_igazolas" label="Az MTA Bolyai János Kutatási Ösztöndíj elnyeréséről szóló értesítés" name="bolyai_kutatasi_osztondij_elnyerese_igazolas" :loaded_files="form.values.bolyai_kutatasi_osztondij_elnyerese_igazolas"/>
          </div>
          <div v-show="abszolutoriumMegszerzesetIgazoloDokumentumElektronikusanLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan" label="Az abszolutórium megszerzését igazoló dokumentum elektronikusan (Amennyiben a pályázó az abszolutóriumot nem szerezte meg, a pályázó által aláírt nyilatkozat arról, hogy az ösztöndíjszerződés megkötéséig az abszolutóriumot várhatóan megszerzi)" name="abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan" :loaded_files="form.values.abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan"/>
          </div>
          <div v-show="phdDlaFokozatMegszerzesetIgazoloDokumentumLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'phd_dla_fokozat_megszerzeset_igazolo_dokumentum'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="phd_dla_fokozat_megszerzeset_igazolo_dokumentum" label="A PhD/DLA fokozat megszerzését igazoló dokumentum (amennyiben a pályázat benyújtásakor a fokozatot megszerezte)" name="phd_dla_fokozat_megszerzeset_igazolo_dokumentum" :loaded_files="form.values.phd_dla_fokozat_megszerzeset_igazolo_dokumentum"/>
          </div>

          <div v-show="nyelvtudastIgazoloDokumentumLatszik()" class="col-xs-12">
            <h5 class="form-block-title">
              Opcionális mellékletek
            </h5>
          </div>
          <div v-show="nyelvtudastIgazoloDokumentumLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'nyelvtudast_igazolo_dokumentum'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="nyelvtudast_igazolo_dokumentum" label="Nyelvtudást igazoló dokumentum" name="nyelvtudast_igazolo_dokumentum" :loaded_files="form.values.nyelvtudast_igazolo_dokumentum"/>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="nyilatkozat_elfogadasa" name="nyilatkozat_elfogadasa" type="checkbox" value="1" v-model="nyilatkozat_elfogadasa"/>
                <label for="nyilatkozat_elfogadasa">
                  <div class="icon"></div>
                  <div>
                    Jelen pályázati anyagom benyújtásával egyidejűleg kijelentem, hogy nyertes pályázatom esetén az Új Nemzeti Kiválóság Program 2021/2022 ösztöndíjas jogviszony létesítésekor igazolom az ösztöndíjszerződés létesítéséhez, valamint az ösztöndíjas jogviszony fenntartásához szükséges <strong><u>AKTÍV</u> hallgatói jogviszonyomat/ munkaviszonyomat vagy munkavégzésre irányuló egyéb jogviszonyomat</strong>, és vállalom, hogy ezt az ösztöndíjas jogviszony teljes időtartama alatt mindvégig fenntartom.
                  </div>
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozat_elfogadasa'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>

          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save(0)" :disabled="!save_enabled" type="button" name="kuld" class="button">Mentés</button>
              <button v-on:click="save(1)" :disabled="!save_enabled" type="button" name="kuld" class="button">Véglegesít</button>
            </div>
          </div>

      </template>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info"></div>

          <div v-if="remedy">
            <div style="margin-top: 30px;" class="info-box warning">
              Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.
            </div>
            <a href="javascript:void(0)" title="" v-on:click="remedy_popup = true;" class="button">Fellebezés</a>
          </div>

          <div style="margin-top: 40px;" class="info-box" v-if="remedy_user != false">
            <div class="title">Fellebezés</div>
            <div><span class="highlight">{{ remedy_user.name }}</span> ({{remedy_user.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_user.msg)">
            </div>
          </div>

          <div style="margin-top: 20px;" class="info-box" v-if="remedy_admin != false">
            <div class="title">Fellebezés válasz</div>
            <div><span class="highlight">{{ remedy_admin.name }}</span> ({{remedy_admin.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_admin.msg)">
            </div>
          </div>

        </div>
      </div>
    </div>
    <Fellebezes v-on:close="(final) => { remedy_popup = false; if (final) remedy = false; }" v-if="remedy && $route.query.id != undefined && remedy_popup" :form_id="$route.query.id"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Fellebezes from './fellebezes.vue';

export default {
  components: {
    Fellebezes
  },
  data: function() {
    return {
      igen_nem:[{value:'igen',label:'Igen'},{value:'nem',label:'Nem'}],palyazhato_osztondijak:[{value:'',label:'- válasszon -',group:''},{value:'21_1_1',label_short:'ÚNKP-21-1-I',label:'ÚNKP-21-1-I Felsőoktatási Alapképzés Hallgatói Kutatói Ösztöndíj - jelenleg alapképzésben tanuló, "leendő felsőbb éves"',group:'21_1'},{value:'21_1_2',label_short:'ÚNKP-21-1-II',label:'ÚNKP-21-1-II Felsőoktatási Alapképzés Hallgatói Kutatói Ösztöndíj - alapképzésre felvételizett, "leendő elsőéves"',group:'21_1'},{value:'21_2_1',label_short:'ÚNKP-21-2-I',label:'ÚNKP-21-2-I Felsőoktatási Mesterképzés Hallgatói Kutatói Ösztöndíj - jelenleg mester (osztatlan) képzésben tanuló',group:'21_2'},{value:'21_2_2',label_short:'ÚNKP-21-2-II',label:'ÚNKP-21-2-II Felsőoktatási Mesterképzés Hallgatói Kutatói Ösztöndíj - mester (osztatlan) képzésre felvételizett',group:'21_2'},{value:'21_3_1',label_short:'ÚNKP-21-3-I',label:'ÚNKP-21-3-I Felsőoktatási Doktori Hallgatói Kutatói Ösztöndíj - komplex vizsga előtti doktori hallgató, vagy 2021/2022. tanévre meghirdetett doktori képzésre felvételi jelentkezési kérelmet benyújtó hallgató',group:'21_3'},{value:'21_3_2',label_short:'ÚNKP-21-3-II',label:'ÚNKP-21-3-II Felsőoktatási Doktori Hallgatói Kutatói Ösztöndíj - jelenleg doktori képzésben tanuló, komplex vizsgáját az ösztöndíjas jogviszony kezdetéig teljesítő hallgató',group:'21_3'},{value:'21_4_1',label_short:'ÚNKP-21-4-I',label:'ÚNKP-21-4-I „Tudománnyal fel!” Felsőoktatási Doktorvárományosi és Posztdoktori Kutatói Ösztöndíj - doktorvárományos',group:'21_4'},{value:'21_4_2',label_short:'ÚNKP-21-4-II',label:'ÚNKP-21-4-II „Tudománnyal fel!” Felsőoktatási Doktorvárományosi és Posztdoktori Kutatói Ösztöndíj - posztdoktor',group:'21_4'},{value:'21_5',label_short:'ÚNKP-21-5',label:'ÚNKP-21-5 Bolyai+ Felsőoktatási Fiatal Oktatói, Kutatói Ösztöndíj',group:'21_5'},{value:'21_6',label_short:'ÚNKP-21-6',label:'ÚNKP-21-6 „Tehetséggel fel!” Felsőoktatást Megkezdő Kutatói Ösztöndíj',group:'21_6'}],tudomanyteruletek:[{value:'agrártudományok',label:'Agrártudományok',tudomanyagak:[{value:'állatorvosi tudományok',label:'Állatorvosi tudományok'},{value:'állattenyésztési tudományok',label:'Állattenyésztési tudományok'},{value:'élelmiszertudományok',label:'Élelmiszertudományok'},{value:'erdészeti és vadgazdálkodási tudományok',label:'Erdészeti és vadgazdálkodási tudományok'},{value:'növénytermesztési és kertészeti tudományok',label:'Növénytermesztési és kertészeti tudományok'}]},{value:'bölcsészettudományok',label:'Bölcsészettudományok',tudomanyagak:[{value:'filozófiai tudományok',label:'Filozófiai tudományok'},{value:'irodalom- és kultúratudományok',label:'Irodalom- és kultúratudományok'},{value:'művészettörténeti és művelődéstörténeti tudományok',label:'Művészettörténeti és művelődéstörténeti tudományok'},{value:'művészettudomány',label:'Művészettudomány'},{value:'néprajz- és kulturális antropológia',label:'Néprajz- és kulturális antropológia'},{value:'neveléstudományok',label:'Neveléstudományok'},{value:'nyelvtudományok',label:'Nyelvtudományok'},{value:'pszichológiai tudományok',label:'Pszichológiai tudományok'},{value:'történelemtudományok',label:'Történelemtudományok'},{value:'vallástudományok',label:'Vallástudományok'}]},{value:'hittudományok',label:'Hittudományok',tudomanyagak:[{value:'hittudományok',label:'Hittudományok'}]},{value:'műszaki tudományok',label:'Műszaki tudományok',tudomanyagak:[{value:'agrárműszaki tudományok',label:'Agrárműszaki tudományok'},{value:'anyagtudományok és technológiák',label:'Anyagtudományok és technológiák'},{value:'bio-, környezet- és vegyészmérnöki tudományok',label:'Bio-, környezet- és vegyészmérnöki tudományok'},{value:'építészmérnöki tudományok',label:'Építészmérnöki tudományok'},{value:'építőmérnöki tudományok',label:'Építőmérnöki tudományok'},{value:'gépészeti tudományok',label:'Gépészeti tudományok'},{value:'informatikai tudományok',label:'Informatikai tudományok'},{value:'katonai műszaki tudományok',label:'Katonai műszaki tudományok'},{value:'közlekedés- és járműtudományok',label:'Közlekedés- és járműtudományok'},{value:'villamosmérnöki tudományok',label:'Villamosmérnöki tudományok'}]},{value:'művészetek',label:'Művészetek',tudomanyagak:[{value:'építőművészet',label:'Építőművészet'},{value:'film- és videoművészet',label:'Film- és videoművészet'},{value:'iparművészet',label:'Iparművészet'},{value:'képzőművészet',label:'Képzőművészet'},{value:'multimédia-művészet',label:'Multimédia-művészet'},{value:'színházművészet',label:'Színházművészet'},{value:'tánc- és mozdulatművészet',label:'Tánc- és mozdulatművészet'},{value:'zeneművészet',label:'Zeneművészet'}]},{value:'orvostudományok',label:'Orvostudományok',tudomanyagak:[{value:'egészségtudományok',label:'Egészségtudományok'},{value:'elméleti orvostudományok',label:'Elméleti orvostudományok'},{value:'gyógyszerészeti tudományok',label:'Gyógyszerészeti tudományok'},{value:'klinikai orvostudományok',label:'Klinikai orvostudományok'},{value:'sporttudományok',label:'Sporttudományok'}]},{value:'társadalomtudományok',label:'Társadalomtudományok',tudomanyagak:[{value:'állam- és jogtudományok',label:'Állam- és jogtudományok'},{value:'gazdálkodás- és szervezéstudományok',label:'Gazdálkodás- és szervezéstudományok'},{value:'hadtudományok',label:'Hadtudományok'},{value:'közgazdaságtudományok',label:'Közgazdaságtudományok'},{value:'közigazgatás-tudományok',label:'Közigazgatás-tudományok'},{value:'média-és kommunikációs tudományok',label:'Média-és kommunikációs tudományok'},{value:'politikatudományok',label:'Politikatudományok'},{value:'regionális tudományok',label:'Regionális tudományok'},{value:'rendészettudomány',label:'Rendészettudomány'},{value:'szociológiai tudományok',label:'Szociológiai tudományok'}]},{value:'természettudományok',label:'Természettudományok',tudomanyagak:[{value:'biológiai tudományok',label:'Biológiai tudományok'},{value:'fizikai tudományok',label:'Fizikai tudományok'},{value:'földtudományok',label:'Földtudományok'},{value:'kémiai tudományok',label:'Kémiai tudományok'},{value:'környezettudományok',label:'Környezettudományok'},{value:'matematika- és számítástudományok',label:'Matematika- és számítástudományok'}]}],
      jogviszonyidotartamok: [],
      tudomanyagak: [],
      fill_info: '',
      errors: [],
      save_enabled: false,
      hallgato_alapadatok_t: [],
      szak_combo_opts: [],
      szak_combo_index: 0,
      remedy: false,
      remedy_popup: false,
      remedy_admin: false,
      remedy_user: false,
      nyilatkozat_elfogadasa: false,
      form: {
        name: '',
        values: {
          palyazati_azonosito: '',
          osztondij: '',
          osztondij_id: '',
          jogviszony_idotartam: '5 hónap',
          unkp_reszesult_e: 'nem',
          tema_cim: '',
          tudomanyterulet: 'agrártudományok',
          tudomanyag: 'állatorvosi tudományok',
          temavezeto_neve: '',
          temavezeto_email: '',
          temavezeto_mobil: '',
          makovecz_hallgatoi_osztondijprogram_reszvetel: 'nem',
          makovecz_igazolas: [],
          pro_scientia_arte_reszvetel: 'nem',
          pro_scientia_arte_igazolas: [],
          otdk_reszvetel: 'nem',
          otdk_reszvetel_igazolas: [],
          kutatocsoport_egyuttmukodes: 'nem',
          kutatocsoport_egyuttmukodes_igazolas: [],
          palyazati_adatlap: [],
          palyazati_adatlap_szerkesztheto: [],
          alairt_kutatasi_terv: [],
          alairt_palyazoi_nyilatkozat: [],
          alairt_intezmenyi_fogado_nyilatkozat: [],
          tehetseggel_fel_igazolas: [],
          tanulmanyi_eredmeny_igazolas: [],
          tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio: [],
          nyelvtudast_igazolo_dokumentum: [],
          hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve: [],
          abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan: [],
          phd_dla_fokozat_megszerzeset_igazolo_dokumentum: []
        },
        hallgato_alapadatok: {
          nev: '',
          neptunkod: '',
          szulhelyido: '',
          kar: '',
          szak: '',
          kepzes_szint: '',
          mobilszam: '',
          email: ''
        },
        prev_academic_year: ''
      }
    }
  },
  watch: {
    'form.values.osztondij_id': function() {
      var _this = this;

      this.palyazhato_osztondijak.map(function(po) {
        if (po.value == _this.form.values.osztondij_id)
          _this.form.values.osztondij = po.label;
      });
    }
  },
  mounted: function() {
  	var _this = this;

    this.form.id = this.$route.query.id;

    this.$root.ajax('form/unkp2021_kitoltes_ellenorzes/' + this.$route.query.id, {
      success: function(response) {
        if (response.error) {
          swal('Hiba!',response.error,'error');
        } else {
          if (response.redirect_path != undefined) {
            _this.$router.push({path: response.redirect_path});
            return;
          }

          _this.fill_info = response.fill_info;
          _this.form.name = response.form_name;
          _this.form.academic_year = response.academic_year;
          _this.remedy = response.remedy;

          if (response.remedy_admin != undefined)
            _this.remedy_admin = response.remedy_admin;

          if (response.remedy_user != undefined)
            _this.remedy_user = response.remedy_user;

          if (!Array.isArray(response.hallgato_alapadatok))
            _this.form.hallgato_alapadatok = $.extend({}, _this.form.hallgato_alapadatok, response.hallgato_alapadatok);

          if (response.hallgato_alapadatok_t.length > 0)
            _this.hallgato_alapadatok_t = response.hallgato_alapadatok_t;

          // Szak választó combó adatok a hallgató alapadatok tömbből
          _this.hallgato_alapadatok_t.map(function(h, i) {
            _this.szak_combo_opts.push({
              value: i,
              label: h.szak + ' ' + h.kepzes_szint + ' (' + h.tagozat + ')'
            });
          });

          // Betöltött adat beállítása
          if (response.saved_data != undefined && response.saved_data != '') {
            _this.form.values = response.saved_data.values;
            _this.tudomanyAgak(false);

            // Szak combó visszaállítása
            if (response.saved_data.szakkod != undefined) {
              _this.hallgato_alapadatok_t.map(function(ha, i) {
                if (ha.szakkod == response.saved_data.szakkod)
                  _this.szak_combo_index = i;
              });
            }

            _this.jogviszonyIdotartamOpciok();

          } else {
            _this.tudomanyAgak(true);
          }


          _this.save_enabled = true;
        }
      }
    });
  },
  computed: {
    elozo_tanev: function() {
      if(this.form.prev_academic_year) {
        return '(' + this.form.prev_academic_year + ')';
      } else {
        return '';
      }
    }
  },
  methods: {
    jogviszonyIdotartamOpciok: function() {
      switch(this.form.values.osztondij_id) {
        case '21_1_1':
        case '21_1_2':
        case '21_2_1':
        case '21_2_2':
          this.jogviszonyidotartamok = [{value:'5 hónap',label:'5 hónap'},{value:'10 hónap',label:'10 hónap'}];
        break;

        case '21_3_1':
        case '21_3_2':
          this.jogviszonyidotartamok = [{value:'5 hónap',label:'5 hónap'},{value:'7 hónap',label:'7 hónap'},{value:'12 hónap',label:'12 hónap'}];
        break;

        case '21_4_1':
          this.jogviszonyidotartamok = [{value:'6 hónap',label:'6 hónap'},{value:'12 hónap',label:'12 hónap'}];
        break;

        case '21_4_2':
          this.jogviszonyidotartamok = [{value:'12 hónap',label:'12 hónap'}];
        break;

        case '21_5':
          this.jogviszonyidotartamok = [{value:'12 hónap',label:'12 hónap'}];
        break;

        case '21_6':
          this.jogviszonyidotartamok = [{value:'5 hónap',label:'5 hónap'}, {value:'10 hónap',label:'10 hónap'}];
        break;
      }
    },

    tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioCim: function() {
      var csoport = this.getAktivOsztondijCsoport();

      if (['21_3'].indexOf(csoport) > -1) {
        return 'Pályázat benyújtásáig megvalósult, a pályázat benyújtását megelőző 5 év tudományos/művészeti tevékenységét bemutató, elismerő dokumentáció';
      } else if (['21_4'].indexOf(csoport) > -1) {
        return 'A pályázó teljesítményét alátámasztó dokumentumok (amennyiben a pályázó rendelkezésére áll, pl. publikációs lista, konferencia részvételt, kiállítást igazoló dokumentumok, további tudományos teljesítmény dokumentációja, szakmai-közösségi tevékenység, kutatásokban, kutatási terepmunkában való részvétének igazolása, tudományos ismeretterjesztő/tudomány népszerűsítő tevékenység dokumentációja, egyéb szakmai (tudományos és oktatási) tevékenységet bemutató dokumentáció.';
      } else {
        return 'Pályázat benyújtásáig megvalósult tudományos/művészeti tevékenységét bemutató, elismerő dokumentáció';
      }
    },

    hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveCim: function() {
      var s = 'Hallgatói/munkáltatói jogviszonyigazolás Tanulmányi Osztály / Doktori Iskola / Humánerőforrás Osztály által hitelesítve';

      if (this.form.values.osztondij_id == '21_5' || this.form.values.osztondij_id == '21_4_1' || this.form.values.osztondij_id == '21_4_2') {
        s = s + ' (ennek hiányában a munkáltatói jogkör gyakorlója által ellenjegyzett, pályázó által írt és aláírt nyilatkozat, hogy a 2021. szeptember 1. - 2022. augusztus 31. közötti oktatói, kutatói munkavégzésre irányuló jogviszonya, vagy munkavégzésre irányuló egyéb jogviszonya legkésőbb 2021. szeptember 1. napjáig várhatóan keletkezik.)';
      }

      return s;
    },

    bizonyitvanyMasolatLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_1_2':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    bolyaiKutatasiOsztondijElnyereseIgazolasLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_5':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    abszolutoriumMegszerzesetIgazoloDokumentumElektronikusanLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_4_1':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    phdDlaFokozatMegszerzesetIgazoloDokumentumLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_4_2':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_3_1':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    felviHuJelentkezesiAdatlapLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_1_2':
        case '21_2_2':
        case '21_6':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveLatszik: function() {
      switch(this.form.values.osztondij_id) {
        case '21_1_1':
        case '21_2_1':
        case '21_3_1':
        case '21_3_2':
        case '21_5':
        case '21_4_1':
        case '21_4_2':
          return true;
        break;

        default:
          return false;
        break;
      }
    },

    tudomanyAgak: function(ertek_beallitas) {
      var _this = this;

      this.tudomanyteruletek.map(function(tudomanyterulet) {
        if (tudomanyterulet.value == _this.form.values.tudomanyterulet)
          _this.tudomanyagak = tudomanyterulet.tudomanyagak;
      });

      if (ertek_beallitas)
        this.form.values.tudomanyag = this.tudomanyagak[0].value;
    },

    neptunkodLatszik: function() {
      if (this.form.values.osztondij_id == '21_1_1' || this.form.values.osztondij_id == '21_2_1' || this.form.values.osztondij_id == '21_2_2' || this.form.values.osztondij_id == '21_3_1' || this.form.values.osztondij_id == '21_3_2' || this.form.values.osztondij_id == '21_4_1') {
        return true;
      } else {
        return false;
      }
    },

    szakLatszik: function() {
      var csoport = this.getAktivOsztondijCsoport();
      if (csoport == '') {
        return false;
      } else if (['21_1','21_2','21_3','21_4','21_6'].indexOf(csoport) > -1) {
        return true;
      } else {
        return false;
      }
    },

    karLatszik: function() {
      var csoport = this.getAktivOsztondijCsoport();

      if (csoport == '') {
        return false;
      } else if (['21_5'].indexOf(csoport) > -1) {
        return true;
      } else {
        return false;
      }
    },

    temavezetoNevKitoltes: function() {
      if (['21_5'].indexOf(this.getAktivOsztondijCsoport()) > -1 || this.form.values.osztondij_id == '21_4_2')
        return true;
      else
        return false;
    },

    temavezetoEmailKitoltes: function() {
      if (['21_5'].indexOf(this.getAktivOsztondijCsoport()) > -1 || this.form.values.osztondij_id == '21_4_2')
        return true;
      else
        return false;
    },

    temavezetoTelefonKitoltes: function() {
      if (['21_5'].indexOf(this.getAktivOsztondijCsoport()) > -1 || this.form.values.osztondij_id == '21_4_2')
        return true;
      else
        return false;
    },

    makoveczLatszik: function() {
      if (['21_1','21_2'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    proScientiaLatszik: function() {
      if (['21_1','21_2','21_3'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    otdkLatszik: function() {
      if (['21_1','21_2','21_3'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    kutatocsoportEgyuttmukodesLatszik: function() {
      if (['21_1','21_2','21_3','21_4'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    tehetseggelFelIgazolasLatszik: function() {
      if (['21_6'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    tanulmanyiEredmenyIgazolasLatszik: function() {
      if (['21_1','21_2','21_6'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioLatszik: function() {
      if (['21_1','21_2','21_3','21_4'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    nyelvtudastIgazoloDokumentumLatszik: function() {
      if (['21_1','21_2','21_3','21_4'].indexOf(this.getAktivOsztondijCsoport()) > -1)
        return true;
      else
        return false;
    },

    getAktivOsztondijCsoport: function() {
      var _this = this;
      var csoport = '';

      this.palyazhato_osztondijak.map(function(osztondij) {
        if (osztondij.value == _this.form.values.osztondij_id)
          csoport = osztondij.group;
      });

      return csoport;
    },

    getFieldByName: function(field_name) {
      var f;
      this.form.fields.map(function(field) {
        if (field.name == field_name)
          f = field;
      });
      return f;
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];

      this.form.osztondijcsoport = this.getAktivOsztondijCsoport();

      this.$root.ajax('form/unkp2021_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          palyazhato_osztondijak: JSON.stringify(this.palyazhato_osztondijak),
          veglegesit: veglegesit,
          nyilatkozat_elfogadasa: this.nyilatkozat_elfogadasa
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    },

    changeValue: function(value, name) {
      this.form.values[name] = value;
    },

    szakValt: function(index) {
      this.form.hallgato_alapadatok = $.extend({}, this.form.hallgato_alapadatok, this.hallgato_alapadatok_t[index]); // Email cím, mobilszám ne vesszen el
    },

    osztondijValtoztat: function() {
      this.form.values.makovecz_hallgatoi_osztondijprogram_reszvetel = 'nem';
      this.form.values.makovecz_igazolas = [];
      this.form.values.pro_scientia_arte_reszvetel = 'nem';
      this.form.values.pro_scientia_arte_igazolas = [];
      this.form.values.otdk_reszvetel = 'nem';
      this.form.values.otdk_reszvetel_igazolas = [];
      this.form.values.kutatocsoport_egyuttmukodes = 'nem';
      this.form.values.kutatocsoport_egyuttmukodes_igazolas = [];
      this.tehetseggel_fel_igazolas = [];
      this.tanulmanyi_eredmeny_igazolas = [];
      this.tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio = [];
      this.hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve = [];
      this.felvi_hu_jelentkezesi_adatlap = [];
      this.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve = [];
      this.bizonyitvany_masolat = [];
      this.bolyai_kutatasi_osztondij_elnyerese_igazolas = [];
      this.errors = [];
      this.jogviszonyIdotartamOpciok();
      this.form.values.jogviszony_idotartam = this.jogviszonyidotartamok[0].value;
    }
  }
}
</script>



// WEBPACK FOOTER //
// unkp2021.vue?12a9a307